






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BrandedFooter from "../components/BrandedFooter.vue";
import MainMenu from "../components/MainMenu.vue";
import NamePlate from "../components/NamePlate.vue";
import SnackbarStore from "../components/SnackbarStore.vue";
import { MenuItem, TComponent } from "../../bootstrap";
import { namespace } from "vuex-class";
import { getGlobalInfo } from "../../api";
import { Route } from "vue-router";

const authStore = namespace("auth");

@Component({
  components: { BrandedFooter, MainMenu, NamePlate, SnackbarStore },
})
export default class App extends Vue {
  @authStore.Getter loggedIn!: boolean;
  @authStore.Action setLoggedIn!: (state: boolean) => Promise<void>;
  @authStore.Mutation clearProfile!: () => void;
  @authStore.Action ensureProfile!: () => void;

  drawer = true;
  loginStatus: boolean | null = null;
  userID = "";
  childTitle = "";

  @Prop({ required: true })
  title!: string;

  @Prop({ required: true })
  menuItems!: MenuItem[];

  @Prop({ required: true })
  authCheck!: boolean;

  @Prop({ required: true })
  branding!: boolean;

  @Prop({ default: undefined })
  customToolbar?: TComponent[];

  get showCustom(): boolean {
    return this.customToolbar !== undefined && this.customToolbar.length > 0;
  }

  get displayTitle(): string {
    const routerTitle =
      this.$route.meta === undefined || this.$route.meta.title === undefined
        ? ""
        : this.$route.meta.title;
    return this.childTitle === "" ? routerTitle : this.childTitle;
  }

  get fullTitle(): string {
    if (this.displayTitle === "") return this.title;
    return `${this.title} - ${this.$t(this.displayTitle)}`;
  }

  @Watch("$route")
  onRouteChange(n: Route, o: Route): void {
    if (n === o) return;
    this.childTitle = "";
  }

  private mounted(): void {
    if (!this.authCheck) {
      return;
    }
    // TODO: place in a mixin
    const checkStatus = async () => {
      setTimeout(checkStatus, 300000);
      try {
        const info = await getGlobalInfo();

        if (this.loginStatus === null) {
          this.loginStatus = info.logged_in;
          this.userID = info.user_id;
        } else {
          if (this.loginStatus !== info.logged_in) {
            this.setLoggedIn(info.logged_in);
            location.reload();
          }
          if (this.userID !== info.user_id) {
            this.clearProfile();
            this.ensureProfile();
          }
        }
      } catch (e) {
        if (!this.loginStatus) {
          this.$router.push({ name: "login-request" });
        }
      }
    };

    checkStatus();
  }

  @Watch("fullTitle", { immediate: true })
  setPageTitle(title: string): void {
    document.title = title;
  }

  @Watch("loggedIn")
  onLogin(val: boolean, oldVal: boolean): void {
    if (val !== oldVal) this.loginStatus = val;
  }
}
